import Tab from '../../components/_common/Tab'
import './style.css'
import { useLocation, useNavigate } from "react-router-dom";
import SearchModal from './Search/SearchModal';
import { Alert, Button, Modal } from 'antd';
import { errorNotify } from '../../services/toast.notification';
import { CheckConnection, getLabInfo, getLabList, getVerifyBackup, iisIsAvailable, isSqlServerAvailable, pingIsAvailable } from '../../api/api';
import { useEffect, useState } from 'react';
import { UpdateGeneralInfo } from '../../redux/reducers/GeneralInfoSlice';
import { useAppDispatch, useAppSelector } from '../../redux/store/storehooks';
import {
    CheckCircleFilled,
    CloseCircleFilled,
    GlobalOutlined,
    DesktopOutlined,
    DatabaseOutlined
} from '@ant-design/icons';
import jalali_moment from 'jalali-moment';
import Spinner from '../../components/_common/Spinner';



const StatusIcon = ({
    status,
    icon: Icon
}: {
    status: boolean;
    icon: any;
}) => {
    return (
        <div className={`status-icon ${status ? 'status-success' : 'status-error'}`}>
            <Icon />
            {status ? (
                <CheckCircleFilled className="status-badge" />
            ) : (
                <CloseCircleFilled className="status-badge" />
            )}
        </div>
    );
};


const LabInfo = () => {
    const { state } = useLocation();
    const { id, name, tel, website, url: url, serviceUrl: serviceUrl } = state; // Read values passed on state
    const [isLoading, setIsLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [backupString, setBackupString] = useState("");
    const [isConnectionModalOpen, setIsConnectionModalOpen] = useState(false);

    const [connectionStatus, setConnectionStatus] = useState({
        ping: false,
        iis: false,
        sql: false,
    });

    const navigate = useNavigate();
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();

    const USformatter = new Intl.NumberFormat("en-US");

    const navigateProxy = () => {
        navigate("/parsicuser/proxy")
    }

    const _getVerifyBackup = () => {
        getVerifyBackup(url)
            .then((result: any) => {
                if (result.status === 200) {
                    setBackupString("بکاپ گرفته شده صحیح است.")
                }
                else {
                    setBackupString("بکاپ گرفته شده مشکل دارد.")
                }
                setIsLoading(false);

            })
            .catch((error) => {
                setIsLoading(false);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })


    }


    const _checkSqlServerAvailable = () => {
        isSqlServerAvailable(url)
            .then((result: any) => {
                if (result) {
                    if(result.data == 'OK'){
                    setConnectionStatus({
                        ping: true,
                        iis: true,
                        sql: true,
                    });
                    _checkIIS();
                }
                }
                else {
                    setConnectionStatus({
                        ping: true,
                        iis: true,
                        sql: false,
                    });
                    setIsLoading(false);
                }

            })
            .catch((error) => {
                setIsLoading(false);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const _checkPing = () => {
        pingIsAvailable(serviceUrl)
            .then((result: any) => {
                if (result) {
                    if (result.data == "true") {
                        setConnectionStatus({
                            ping: true,
                            iis: false,
                            sql: false,
                        });
                        _checkIIS();
                    }
                }
                else {
                    setConnectionStatus({
                        ping: false,
                        iis: false,
                        sql: false,
                    });
                    setIsLoading(false);
                }

            })
            .catch((error) => {
                setIsLoading(false);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }


    const _checkIIS = () => {
        iisIsAvailable(serviceUrl)
            .then((result: any) => {
                if (result) {
                    if (result.data == "True") {
                        setConnectionStatus({
                            ping: true,
                            iis: true,
                            sql: false,
                        });
                        _checkSqlServerAvailable();
                    }
                }
                else {
                    setConnectionStatus({
                        ping: true,
                        iis: false,
                        sql: false,
                    });
                }
                setIsLoading(false);

            })
            .catch((error) => {
                setIsLoading(false);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const openConnectionModal = () => {
        setIsConnectionModalOpen(true);
        setIsLoading(true);
        setConnectionStatus({
            ping: false,
            iis: false,
            sql: false,
        });
        _checkPing();
    };

    const downloadParsiTel = () => {
        window.open('https://s30.picofile.com/d/8474902134/1dfb326f-94ec-477f-a3d2-752b94c808ea/Ver_11_68_14020623.apk', "_blank")
    }


    const _getLabInfo = () => {

        getLabInfo(serviceUrl)
            .then((jsonResult: any) => {
                //let jsonResult = JSON.parse(JSON.stringify(result));
                //alert(jsonResult.CentralVer);
                let sqlVer = jsonResult.SQLVersion.split(" - ");
                dispatch(UpdateGeneralInfo({
                    CentralVer: jsonResult.CentralVer,
                    SQLVersion: sqlVer[0],
                    DsSQLBackupInfo: jsonResult.DsSQLBackupInfo.SqlBackup,
                    DreamLabSendInfo: jsonResult.DreamLabSendInfo.DreamLabSend,
                    ParsicMasterInfo: jsonResult.ParsicMasterInfo.ParsicMaster,
                    MyParsicServiceLog: jsonResult.MyParsicServiceLog,
                    hostname: jsonResult.hostname,
                    IISIpAddress: jsonResult.IISIpAddress,
                    SQLServerIP: jsonResult.SQLServerIP,
                    SMSRemainingCredit: jsonResult.SMSRemainingCredit,
                    SqlServerName: jsonResult.SqlServerName,
                    OsInfo: jsonResult.OsInfo[0],
                    WordVersion: jsonResult.WordVersion[0],
                    ParsicTempAccess: jsonResult.ParsicTempAccess,
                    GoogleConnection: jsonResult.GoogleConnection,
                    ParsiPolServiceConnection: jsonResult.ParsiPolServiceConnection,
                    SqlConnection: jsonResult.SqlConnection,
                    PadvishIsRunning: jsonResult.PadvishIsRunning,
                    PadvishIsInstalled: jsonResult.PadvishIsInstalled,
                    SQLIsInstalled: jsonResult.SQLIsInstalled,
                    PrintCatcherIsInstalled: jsonResult.PrintCatcherIsInstalled,
                    PwebserviceUserInSql: jsonResult.PwebserviceUserInSql,
                    SqlIPPing: jsonResult.SqlIPPing,
                    SqlRemotControlPort: jsonResult.SqlRemotControlPort,
                    CheckParsicSMSServiceStatus: jsonResult.CheckParsicSMSServiceStatus,
                    LastAutoBackupForLastWeek: jsonResult.LastAutoBackupForLastWeek,
                    InetsrvLogFolderIsExist: jsonResult.InetsrvLogFolderIsExist,
                }))
                _getVerifyBackup();
            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })
    }

    const loadLabs = () => {
        if (!myStore.labList.list) {
            getLabList()
                .then((result: any) => {
                    //setData(result.data.data);
                    //setFilteredData(result.data.data);
                    let selectedLab: any = result.data.data.find((lab: any) => lab.Prk_AndriodLab_AutoID == myStore.auth.userId);

                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                    errorNotify(error.response.data.errorMessage, undefined, 5000)
                })
        }
        else {
            let selectedLab: any = myStore.labList.list.find((lab: any) => lab.Prk_AndriodLab_AutoID == myStore.auth.userId);
        }
    }

    useEffect(() => {
        // loadLabs();

        _getLabInfo();
    }, []);


    return (
        <div className='row d-flex container'>
            <div className='col-md-12'>
                <div className='headBox'>
                    <div className='menuIcon' onClick={() => setIsOpen(prev => !prev)}></div>
                </div>
            </div>
            <div className={'col-md-12'}>
                <div className={'card'}>
                    <div className={'card-body'}>
                        <Tab url={url} labId={id} service_url={serviceUrl} isOpen={isOpen} setIsOpen={setIsOpen} />
                    </div>
                </div>
            </div>
            <div className='col-md-6'>
                <div className="card labInfo">
                    <h5 className='card-header'>اطلاعات آزمایشگاه</h5>
                    <div className='card-body'>
                        <div className='mb-3'><span className='general-info-color'>نام:</span><span style={{ float: 'left' }}>{name}</span></div>
                        <div className='mb-3'><span className='general-info-color'>تلفن:</span><span style={{ float: 'left' }}>{tel}</span></div>
                        <div className='mb-3'><span className='general-info-color'>سایت:</span><a target='_blank' href={website} style={{ wordWrap: 'break-word' }}>{website}</a></div>
                        {isLoading === false && (
                            <>
                                <div className='mb-3'><span className='general-info-color'>ورژن سنترال:</span><span style={{ float: 'left' }}>{myStore.generalInfo.CentralVer}</span></div>
                                <div className='mb-3'><span className='general-info-color'>ورژن بانک:</span><span style={{ float: 'left', direction: 'ltr' }}>{myStore.generalInfo.SQLVersion}</span></div>
                                <div className='mb-3'><span className='general-info-color'> ورژن word</span><span style={{ float: 'left' }}>{myStore.generalInfo.WordVersion}</span></div>
                                <div className='mb-3'><span className='general-info-color'>باقیمانده پیامک (تومان) </span><span style={{ float: 'left' }}>{USformatter.format(Number(myStore.generalInfo.SMSRemainingCredit))}</span></div>
                            </>)
                        }
                        {
                            isLoading === true && (
                                <Spinner />
                            )
                        }
                    </div>
                </div>

            </div>
            <div className='col-md-6'>
                <div className="card connectionStatus">
                    <h5 className='card-header'>وضعیت اتصالات</h5>
                    <div className="card-body" >
                        {isLoading === false && (
                            <>
                                <div className='mb-3'>
                                    <span style={{ fontSize: '14px' }}>Internet</span>
                                    <span style={{ float: 'right' }}>{myStore.generalInfo.GoogleConnection ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span>
                                </div>
                                <div className='mb-3'>
                                    <span style={{ fontSize: '14px' }}>Padvish Installed</span>
                                    <span style={{ float: 'right' }}>{myStore.generalInfo.PadvishIsInstalled ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span>
                                </div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>Padvish Running?</span><span style={{ float: 'right' }}>{myStore.generalInfo.PadvishIsRunning ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>PrintCatcher Installed?</span><span style={{ float: 'right' }}>{myStore.generalInfo.PrintCatcherIsInstalled ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>Sql Connection</span><span style={{ float: 'right' }}>{myStore.generalInfo.SqlConnection ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>SQL Installed?</span><span style={{ float: 'right' }}>{myStore.generalInfo.SQLIsInstalled ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>ParsiPol Service Connection</span><span style={{ float: 'right' }}>{myStore.generalInfo.ParsiPolServiceConnection ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>PwebserviceUserInSql</span><span style={{ float: 'right' }}>{myStore.generalInfo.PwebserviceUserInSql ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>Sql IP Ping</span><span style={{ float: 'right' }}>{myStore.generalInfo.SqlIPPing ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>Sql Remot Control Port</span><span style={{ float: 'right' }}>{myStore.generalInfo.SqlRemotControlPort ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>Check Parsic SMS Service</span><span style={{ float: 'right' }}>{myStore.generalInfo.CheckParsicSMSServiceStatus ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>LastAutoBackup LastWeek</span><span style={{ float: 'right' }}>{myStore.generalInfo.LastAutoBackupForLastWeek ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                                <div className='mb-3'><span style={{ fontSize: '14px' }}>InetsrvLogFolder Exist?</span><span style={{ float: 'right' }}>{myStore.generalInfo.InetsrvLogFolderIsExist ? <CheckCircleFilled style={{ color: 'green', fontSize: '20px' }} /> : <CloseCircleFilled style={{ color: 'red', fontSize: '20px' }} />}</span></div>
                            </>
                        )}
                        {
                            isLoading === true && (
                                <Spinner />
                            )
                        }
                    </div>
                </div>
            </div>
            <div className='col-md-6'>
                <div className='card'>
                    <h5 className='card-header'>هشدار ها</h5>
                    <div className='card-body'>
                        {isLoading === false && (
                            <>
                                <div className='mb-3'>{myStore.generalInfo.DsSQLBackupInfo.length > 0 ? <span className='general-info-color' style={{ wordWrap: 'break-word' }}>آخرین بکاپ در تاریخ <span style={{ direction: 'rtl' }}>{jalali_moment(JSON.parse(JSON.stringify(myStore.generalInfo.DsSQLBackupInfo[0])).Date, 'YYYY-MM-DD').locale('fa').format('YYYY-MM-DD')}</span> با آدرس {JSON.parse(JSON.stringify(myStore.generalInfo.DsSQLBackupInfo[0])).Address} گرفته شده است.</span> : <span className='general-info-color'> در دو روز اخیر هیچ بکاپی گرفته نشده است.</span>}</div>
                                <div className='mb-3'>{myStore.generalInfo.DreamLabSendInfo.length > 0 ? <span className='general-info-color' style={{ wordWrap: 'break-word' }}>آخرین دریم در آدرس {JSON.parse(JSON.stringify(myStore.generalInfo.DreamLabSendInfo[0])).URL} انجام شده است.</span> : null}</div>
                                <div className='mb-3'>{myStore.generalInfo.OsInfo.toString().includes("Windows 10 Enterprise") ? null : <span className='general-info-color'>ویندوز وب سرور آزمایشگاه پشتیبانی نمی شود.</span>}</div>
                                <div className='mb-3'>{myStore.generalInfo.ParsicTempAccess.length > 0 ? <span className='general-info-color'>  این آزمایشگاه از دماسنج های شرکت استفاده می کند.  </span> : <span className='general-info-color'> این آزمایشگاه از دماسنج های شرکت استفاده نمی کند.</span>}</div>
                                <div className='mb-3'>{backupString}</div>
                            </>
                        )}
                        {
                            isLoading === true && (
                                <Spinner />
                            )
                        }
                    </div>
                </div>
            </div>
            <div className='col-md-6'>
                <div className='card checkTrueWeb'>
                    <h5 className='card-header'>بررسی صحت وب آزمایشگاه</h5>
                    <div className='card-body'>
                        <div className='mb-3'>
                            <span style={{ fontSize: '14px' }}>بررسی صحت NewLabOnline </span>
                            <span style={{ overflow: "hidden" }}><a href={website} target='_blank' rel="noreferrer">
                                {website}
                            </a>
                            </span>
                        </div>
                        <div className='mb-3' style={{ borderTop: '1px solid lightgray', paddingTop: '10px' }}>
                            <span style={{ fontSize: '14px' }}>بررسی صحت LabAndroid </span>
                            <br />
                            <span style={{ overflow: "hidden" }}><a href={serviceUrl} target='_blank' rel="noreferrer">
                                {serviceUrl}
                            </a>
                            </span>
                        </div>
                        <div className='mb-3' style={{ borderTop: '1px solid lightgray', paddingTop: '10px' }}>
                            <span style={{ fontSize: '14px' }}>بررسی صحت NewLabAndroid </span>
                            <span style={{ overflow: "hidden" }}><a href={url} target='_blank' rel="noreferrer">
                                {url}
                            </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-12'>
                <div className='d-flex justify-content-end gap-2 mb-4'>
                    <Button type="primary" onClick={navigateProxy}>بازگشت</Button>
                    <Button type="primary" onClick={downloadParsiTel}>دانلود پارسی تل</Button>
                    <Button type="primary" onClick={openConnectionModal}>
                        بررسی صحت ارتباط
                    </Button>
                </div>
            </div>


            <SearchModal url={url} serviceUrl={serviceUrl} labId={id} />

            <Modal
                open={isConnectionModalOpen}
                onCancel={() => setIsConnectionModalOpen(false)}
                footer={null}
                width={900}
                centered
            >
                <div className="connection-flow">

                    <div className="connection-step">
                        <StatusIcon
                            status={connectionStatus.ping}
                            icon={GlobalOutlined}
                        />
                        <span>ارتباط با IP و مودم مرکز</span>
                    </div>

                    <div className="connection-arrow">←</div>

                    <div className="connection-step">
                        <StatusIcon
                            status={connectionStatus.iis}
                            icon={DesktopOutlined}
                        />
                        <span>ارتباط با سرور IIS</span>
                    </div>

                    <div className="connection-arrow">←</div>

                    <div className="connection-step">
                        <StatusIcon
                            status={connectionStatus.sql}
                            icon={DatabaseOutlined}
                        />
                        <span>ارتباط با سرور SQL</span>
                    </div>
                </div>
            </Modal>
        </div>




    )
}

export default LabInfo;

